import { render } from "./MealManagement.vue?vue&type=template&id=23b3d9d2&scoped=true&ts=true"
import script from "./MealManagement.vue?vue&type=script&lang=ts"
export * from "./MealManagement.vue?vue&type=script&lang=ts"

import "./MealManagement.vue?vue&type=style&index=0&id=23b3d9d2&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/MoTobi-Web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b3d9d2"]])

export default __exports__